export const getGigya = () => {
  return (window as any).gigya
}

export const hasGigyaLoaded = () => {
  return !!getGigya()
}
